import React from 'react';

import * as AuditActions from 'audit/AuditActions';
import {EXPORT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';
import BenchlingConfig from 'BenchlingConfig';
import notifications from 'notifications';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';

import {resetCanvas} from '../CanvasDAO';

interface GenericCanvasActionsProps {
  canvasId?: string;
}

async function handleResetCanvas(canvasId: string): Promise<void> {
  try {
    const response = await resetCanvas(canvasId);
    const failure = response.deliveryStatus === 'failure';
    if (failure) {
      notifications.error('Could not reach app. Please contact Benchling support if the issue persists.');
    } else {
      notifications.success('Canvas reset successfully. The page will refresh when the new canvas is ready.');
    }
  } catch (error) {
    notifications.error('Could not reset canvas. Please contact Benchling support if issue persists.');
    throw error;
  }
}

const GenericCanvasActions = (props: GenericCanvasActionsProps): JSX.Element => {
  const {canvasId} = props;
  if (!canvasId) {
    return <></>;
  }
  return (
    <Dropdown
      menu={
        <Menu height={MenuHeight.MEDIUM} width={MenuWidth.MEDIUM}>
          <Section>
            <Option
              onSelect={() => {
                AuditActions.exportAuditLogs([canvasId]);
              }}
              dataTestAttrs={{
                component: 'GenericCanvasActions',
                element: 'exportAuditLogs',
              }}
            >
              {EXPORT_AUDIT_LOG_DISPLAY_STRING}
            </Option>
            {BenchlingConfig.ENABLE_HOMEPAGE_CANVAS_REIMPLEMENTED && (
              <Option
                onSelect={() => {
                  handleResetCanvas(canvasId);
                }}
                dataTestAttrs={{
                  component: 'GenericCanvasActions',
                  element: 'resetCanvas',
                }}
              >
                Reset Canvas
              </Option>
            )}
          </Section>
        </Menu>
      }
    >
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className="u-mini-spacing-left"
        icon="overflow"
        size={ButtonSize.SMALL}
        dataTestAttrs={{
          component: 'GenericCanvasActions',
          element: 'actionsButton',
        }}
      />
    </Dropdown>
  );
};

export default GenericCanvasActions;
